import React from "react";
import * as Icons from "lucide-react";
import { Star } from "lucide-react";

// Map to a sensible default if icon string isn't a lucide name
const getIcon = (name) => {
    const Cmp = Icons[name];
    return Cmp || Icons.Globe;
};

export default function AppTile({
    app,
    favorite,
    onLaunch,
    onToggleFavorite,
    rotation = 0,
}) {
    const Icon = getIcon(app.icon);

    const handleStar = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onToggleFavorite?.(app);
    };

    const handleKey = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onLaunch?.(app);
        }
    };

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={() => onLaunch?.(app)}
            onKeyDown={handleKey}
            data-testid={`app-tile-${app.id}`}
            className="group relative bg-white brut-border brut-shadow brut-press cursor-pointer select-none p-4 sm:p-5 flex flex-col h-full"
            style={{ transform: `rotate(${rotation}deg)` }}
        >
            <button
                type="button"
                onClick={handleStar}
                className="absolute top-2 right-2 p-1.5 bg-white brut-border"
                data-testid={`app-tile-fav-${app.id}`}
                aria-label={favorite ? "Unpin app" : "Pin app"}
            >
                <Star
                    size={16}
                    strokeWidth={3}
                    className={
                        favorite
                            ? "fill-[#E8241A] text-[#E8241A]"
                            : "text-black"
                    }
                />
            </button>

            <div className="mb-3 bg-[#E8241A] text-white w-12 h-12 flex items-center justify-center brut-border">
                <Icon size={22} strokeWidth={2.5} />
            </div>

            <div
                className="font-display text-base sm:text-lg leading-tight break-words pr-8"
                data-testid={`app-tile-name-${app.id}`}
            >
                {app.name}
            </div>
            {app.description ? (
                <div className="mt-1 text-xs opacity-70 break-words">
                    {app.description}
                </div>
            ) : null}

            <div className="mt-auto pt-3 flex items-center justify-between">
                <span className="text-[10px] uppercase tracking-widest bg-black text-white px-2 py-0.5">
                    {app.category || "General"}
                </span>
                <span className="text-[10px] uppercase tracking-widest font-display opacity-70 group-hover:opacity-100">
                    Launch ↗
                </span>
            </div>
        </div>
    );
}
